export default __webpack_public_path__ + "static/media/LincolnHeritage.22156d89.png";